<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('reply.menu-templates')"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:instagram-reply-template'})"
        >
          {{ $t('reply.add-template') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
        @edit="goEdit"
        @delete="handleDelete"
      >
        <template
          slot="message_type-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            {{ $t(`reply.${props.row.message_type}`) }}
          </b-badge>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import InstagramReplyApi from '@/api/instagram/reply'
import ReplyTemplateTableConfig from './config/reply-templates-table-config'

export default {
  components: {
    EmptyCard,
    OkTable,
    BBadge,
    BButton,
  },
  data() {
    return {
      config: ReplyTemplateTableConfig,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'instagram/currentAccountId',
      currentPage: 'instagram/currentAccount',
    }),
  },
  watch: {
    currentPageId() {
      this.refreshTable()
    },
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    goEdit(props) {
      this.$router.push({ name: 'owner:instagram-reply-template-edit', params: { id: props.row.id } })
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('reply.delete-reply-template-message'), {
        preConfirm: () => InstagramReplyApi.deleteReplyTemplate(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
